import { Dispatch, SetStateAction } from 'react';
import { SEOSegmentationFilterInput, HousekeepingService } from '@/__generated__/globalTypes';
import { MultiSelectPills } from '../../MultiSelectPills';

type CanHelpWithProps = {
  canHelpWithServices: SEOSegmentationFilterInput['housekeepingSubServices'];
  setCanHelpWithServices: Dispatch<
    SetStateAction<SEOSegmentationFilterInput['housekeepingSubServices']>
  >;
};

const CanHelpWith = ({ canHelpWithServices, setCanHelpWithServices }: CanHelpWithProps) => {
  const homeCareSubServicesOptions = [
    { label: 'Bathroom cleaning', value: HousekeepingService.BATHROOM_CLEANING },
    { label: 'Carpet cleaning', value: HousekeepingService.CARPET_CLEANING },
    { label: 'Kitchen cleaning', value: HousekeepingService.KITCHEN_CLEANING },
    { label: 'Laundry', value: HousekeepingService.LAUNDRY },
    { label: 'Window cleaning', value: HousekeepingService.WINDOW_WASHING },
  ];

  const handleOnChangeEvent = (values: HousekeepingService[]) => {
    setCanHelpWithServices(values);
  };

  return (
    <MultiSelectPills
      sectionName="Can help with"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={homeCareSubServicesOptions}
      category="HOME_CARE_CAN_HELP_WITH"
      selectedValues={canHelpWithServices || []}
    />
  );
};

export { CanHelpWith };
